import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

interface PropsTypes {
  label: string;
  value: string;
  textfieldProps?: TextFieldProps;
}

export default function FieldInfo(props: PropsTypes): React.ReactNode {
  const handleDoubleClick = async () => {
    if (props.value) {
      await navigator.clipboard.writeText(props.value);
    }
  };

  // Format MAC address to uppercase if it matches MAC pattern
  let displayValue = props.value;
  if (displayValue && props.label === 'MAC Address' && /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/.test(displayValue)) {
    displayValue = displayValue.toUpperCase();
  }

  return <TextField
    value={displayValue || ''}
    label={props.label}
    size='small'
    variant='standard'
    focused={false}
    slotProps={{
      input: {
        readOnly: true,
        onDoubleClick: handleDoubleClick
      }
    }}
    {...props.textfieldProps}
  />;
}